import { render, staticRenderFns } from "./AppNavbarSecondary2.vue?vue&type=template&id=2555ca93"
import script from "./AppNavbarSecondary2.vue?vue&type=script&lang=ts"
export * from "./AppNavbarSecondary2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports